import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  PageEvent,
} from '@angular/material';

import { fromEvent } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
} from 'rxjs/operators';
import {
  SearchPatientReq,
  SearchPatientRes,
} from 'src/app/core/model/v2/practice/searchPatientList';
import { Patient } from 'src/app/core/models/patient/patient';
import {
  PractitionerDocument,
} from 'src/app/core/models/practitioner/practitioner-document';
import { CommonService } from 'src/app/core/services/v2/common.service';
import {
  PreviewDocumentComponent,
} from 'src/app/shared/components/preview-document/preview-document.component';

import { PracticeService } from '../../../core/services/v2/practice.service';
import {
  WindowLoaderService,
} from '../../../shared/components/window-loader/window-loader.service';
import {
  SidebarPhysicianEditComponent,
} from '../../profile/physician/sidebar-physician-edit/sidebar-physician-edit.component';
import {
  PhysicianOptionService,
} from '../../shared/physician-option/physician-option.service';

@Component({
  selector: "app-patient-search",
  templateUrl: "./patient-search.component.html",
  styleUrls: ["./patient-search.component.scss"],
})
export class PatientSearchComponent implements OnInit, AfterViewInit {
  uploadedFile: PractitionerDocument;
  userId: number;
  toggleSidebar = false;
  sectionName: string = "referPatient";
  togglePatientProfileSidebar = this.commonService.togglePatientProfileSidebar;
  searchCriteria: string = "";
  showPatientProfile: boolean = false;
  pageLength = 10;
  pageIndex = 1;
  dataLength;
  activeId: number;
  searchData: Patient[];
  openSection: string;

  displayedColumns: string[] = [
    "checkbox",
    "patientName",
    //"gender",
    "contact",
    "aptDateTime",
    "nextAptDateTime",
    "symptoms",
    "action",
  ];
  dataSource: SearchPatientRes[];
  role: string;
  selectedPatient: Patient;
  selection = new SelectionModel<any>(true, []);
  sideBarHeader: string;

  @ViewChild(SidebarPhysicianEditComponent, { static: false })
  childComponent: SidebarPhysicianEditComponent;
  @ViewChild("patientSearchInput", { static: true })
  patientSearchInput: ElementRef;

  constructor(
    private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private commonService: CommonService
  ) { }

  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.searchPatient();
  }

  ngOnInit() {
    console.log(this.physicianOptionService.getPhysician().userId);
    this.physicianOptionService.selectionChange$.subscribe(
      (_) => {
        this.searchCriteria = "";
        this.searchPatient();
      },
      (error) => {
        console.error(error);
      }
    );

    fromEvent(this.patientSearchInput.nativeElement, "keyup")
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.searchCriteria = text;
        this.searchPatient();
      });
  }

  ngAfterViewInit() {
    this.searchPatient();
  }

  togglePatientSidebar(element) {
    this.selectedPatient = element;
    this.openSection = 'profile';
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
    this.showPatientProfile = !this.showPatientProfile;
  }

  togglePatientHealthHistory(element) {
    this.selectedPatient = element;
    this.openSection = 'healthHistory';
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
    this.showPatientProfile = !this.showPatientProfile;
  }


  toggleEditSidebar(
    sectionName: string,
    patient: Patient,
    sideBarHeader: string
  ) {
    if (sectionName !== 'close') {
      this.sectionName = sectionName;
      this.sideBarHeader = sideBarHeader;
      this.activeId = patient && patient.id ? patient.id : undefined;
      this.selectedPatient = patient;
      this.showHideScroll(this.toggleSidebar);
    }
    this.toggleSidebar = !this.toggleSidebar;
    this.destroyChild();
  }

  togglePopUp() {
    // this.practitionerData = pracdata;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }

  destroyChild() {
    if (this.childComponent) {
      this.childComponent.ngOnDestroy();
    }
  }

  searchPatient() {
    const searchReq: SearchPatientReq = new SearchPatientReq();
    searchReq.userId = this.physicianOptionService.getPhysician().userId;
    searchReq.pageIndex = this.pageIndex;
    searchReq.itemsCount = this.pageLength;
    searchReq.criteria = this.searchCriteria;

    if (searchReq.userId) {
      this.loaderService.show();
      this.practiceService.getPractitionerPatientsList(searchReq).subscribe(
        (res) => {
          this.searchData = res.patients;
          this.dataSource = res.patients;
          this.dataLength = res.totalRecords;
          if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
            this.pageIndex = 1;

          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
    }
  }

  getPractitionerPatientDocument() {
    this.practiceService
      .getPractitionerPatientDocument(
        this.physicianOptionService.getPhysician().id
      )
      .subscribe((res) => {
        this.uploadedFile = res;
        console.log(this.uploadedFile);
      });
  }

  attachFile(event) {
    let file: File;
    if (event[0]) {
      file = event[0];
    } else {
      file = event.target.files[0];
    }

    this.practiceService
      .uploadPractitionerPatientDocument(
        this.physicianOptionService.getPhysician().id,
        file
      )
      .subscribe((res) => console.log(res));
  }

  deleteFile(file) {
    this.practiceService
      .deletePractitionerPatientDocument(file.id)
      .subscribe((res) => console.log(res));
  }

  viewFile(file: File) {
    const dialogRef = this.dialog.open(PreviewDocumentComponent, {
      id: "view-dialog",
      width: "90%",
      height: "90%",
      hasBackdrop: true,
      disableClose: true,
      backdropClass: "preview-modal",
      data: { documentLocation: file, isFrame: true },
    });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource);
  }
}
